import axios from 'axios';

// Environment detection
const API_BASE_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:3001/api' : 'https://it4s5zyy9k.execute-api.us-east-1.amazonaws.com/api');

console.log('API Base URL:', API_BASE_URL);

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.log('401 error intercepted, but not redirecting for testing');
      // Temporarily disabled redirect for testing
      // sessionStorage.removeItem('token');
      // sessionStorage.removeItem('userData');
      // window.location.href = '/callback';
    }
    return Promise.reject(error);
  }
);

export default api;